import { Fragment } from "react/jsx-runtime";
import { Container, Row, Col, Image } from "react-bootstrap";

// 1. Define the shape of your step data
interface Step {
  number: string;
  title: string;
  description: string;
}

export function HowItWorks(): JSX.Element {
  // 2. Apply the interface to the array
  const steps: Step[] = [
    {
      number: "1",
      title: "Connect & Share",
      description:
        "One person registers and invites the other. Each person privately shares their side of the story at their own pace.",
    },
    {
      number: "2",
      title: "Align & Choose",
      description:
        "Accordia helps you both identify the real problem, then provides solution options for you to choose together.",
    },
    {
      number: "3",
      title: "Reconcile",
      description:
        "You get an actionable plan with practical and personalized steps to implement the resolution strategy and strengthen your relationship.",
    },
  ];

  return (
    <section id="how-it-works" className="py-4 py-sm-5 py-md-5 bg-transparent">
      <Container>
        {/* Heading + intro copy */}
        <div className="d-flex flex-column align-items-center text-center mb-4 mb-sm-5">
          <h2 className="text-greyscale-default font-family-gabarito fw-bold text-[28px] sm:text-[36px] md:text-[42px] lg:text-[48px] leading-[32px] sm:leading-[40px] md:leading-[48px] lg:leading-3xl">
            How It Works
          </h2>
          <p className="font-family-reddit-sans text-greyscale-subtle mt-2 text-base sm:text-lg md:text-xl leading-[22px] sm:leading-[24px] md:leading-[28px] max-w-[900px] px-3">
            Accordia provides a safe, neutral space where two people can move
            past conflict and work toward resolution, together, at their own
            pace.
          </p>
        </div>

        {/* Steps */}
        <Row className="align-items-center justify-content-center g-4">
          {steps.map((step) => (
            <Fragment key={step.number}>
              <Col
                xs={12}
                md={4}
                className="d-flex flex-column align-items-center text-center"
              >
                <Image
                  src={`/images/how-accordia-works-${step.number}.png`}
                  alt={step.title}
                  className="w-100"
                  style={{
                    maxWidth: 320,
                    maxHeight: 290,
                    objectFit: "contain",
                  }}
                  fluid
                />
                <div className="mt-3">
                  <h3 className="text-greyscale-default font-family-gabarito fw-bold text-xl sm:text-2xl md:text-[28px] leading-[28px] sm:leading-[32px] md:leading-xl">
                    {step.number}. {step.title}
                  </h3>
                  <p className="mt-2 font-family-reddit-sans text-greyscale-subtle text-sm sm:text-base md:text-lg leading-[20px] sm:leading-[22px] md:leading-[24px] px-3 px-md-0">
                    {step.description}
                  </p>
                </div>
              </Col>
            </Fragment>
          ))}
        </Row>
      </Container>
    </section>
  );
}